/**
 * Record ids are bigint primary keys. A path segment that isn't one (a stale
 * bookmark carrying a literal `undefined`, a mistyped URL) can never match a
 * record, and reaches Postgres as an invalid bigint cast — so routes reject it
 * up front instead of firing the query.
 */
export function isRecordId(value: string): boolean {
  return /^\d+$/.test(value);
}
